<template>
  <div class="purchase-detail-container">
    <div class="purchase-detail-header">
      订单详情
    </div>
    <div class="timeline-wrapper">
      <el-steps :active="purchaseDetail.state | purchaseStatusToStep"
                finish-status="success"
                :space="250"
                align-center>
        <el-step title="待收货"
                 :description="purchaseDetail.docDueDate | date"></el-step>
        <el-step title="待处理"
                 :description="purchaseDetail.processingOn | date"></el-step>
        <el-step title="已完成"
                 :description="purchaseDetail.completedOn | date"></el-step>
      </el-steps>
    </div>
    <div class="order-time-wrapper">
      <div class="property-row">
        <span>下单时间</span>
        <span>采购订单</span>
      </div>
      <div class="detail-row">
        <span>{{ purchaseDetail.docDueDate | date }}</span>
        <span>{{ purchaseDetail.docEntry }}</span>
      </div>
    </div>
    <div class="order-list-wrapper">
      <h3 class="title">
        物料清单
      </h3>
      <el-table :data="purchaseDetail.sapPurchaseOrderDetails"
                style="width: 100%">
        <el-table-column type="expand">
          <template slot-scope="scope">
            <div class="batch-list">
              <div class="batch-item-wrapper"
                   v-for="(item,index) in scope.row.purchaseOrderBatchs"
                   :key="index">
                <div class="batch-item">
                  <div class="batch-name">批次号:</div>
                  <div class="data">{{ item.code }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">批次数量:</div>
                  <div class="batch-data">{{ item.quantity }}</div>
                </div>
                <div class="batch-item batch-quality">
                  <div class="batch-name">原始品项:</div>
                  <div class="batch-data">
                    <el-tag :type="item.qualityName | qualityType"
                            size="mini">
                      {{ item.qualityName }}
                    </el-tag>
                  </div>
                </div>
                <!-- <div class="batch-item batch-quality">
                  <div class="batch-name">入库品项:</div>
                  <div class="batch-data">
                    <el-tag :type="item.qualityName | qualityType"
                            size="mini">
                      {{ item.qualityName }}
                    </el-tag>
                  </div>
                </div> -->
                <div class="batch-item">
                  <div class="batch-name">检测报价:</div>
                  <div class="batch-data">{{ item.price }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">处理结果:</div>
                  <div class="batch-data">入库数：{{ item.stockQuantity }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">维修记录:</div>
                  <div class="batch-data">维修数量：{{ item.repairQuantity }}</div>
                </div>
                <div class="batch-item">
                  <div class="batch-name">质检结果:</div>
                  <div class="batch-data">{{ item.result }}</div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="物料名称"
                         prop="itemName">
        </el-table-column>
        <el-table-column label="物料编码"
                         prop="itemCode"
                         width="180">
        </el-table-column>
        <el-table-column label="品牌"
                         prop="brand"
                         width="150">
        </el-table-column>
        <el-table-column label="机型"
                         prop="machine"
                         width="150">
        </el-table-column>
        <el-table-column label="模块"
                         prop="module"
                         width="150">
        </el-table-column>
        <el-table-column label="品项"
                         prop="itemQualityName"
                         width="180">
        </el-table-column>
        <el-table-column label="采购数量"
                         prop="quantity"
                         width="120">
        </el-table-column>
        <el-table-column label="单价"
                         prop="price"
                         width="120">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      purchaseDetail: {}
    };
  },
  beforeCreate () {
    this.$store.commit('setActiveIndex', '/purchase')
    this.$store.commit('setAsideWidth', 150)
  },
  created () {
    this.getPurchaseDetail()
  },
  methods: {
    getPurchaseDetail () {
      const params = {
        id: this.$route.query.id
      }
      this.$http.get('/api/services/inquiryApp/purchaseOrder/GetSap', params)
        .then(res => {
          this.purchaseDetail = res.result
        })
    }
  },
};
</script>
<style lang="less" scoped>
.purchase-detail-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #ffffff;
  font-family: 'Source Han Sans CN';
  padding: 20px;
}
.purchase-detail-header {
  border-bottom: 1px solid #eff2f9;
  display: flex;
  align-items: center;
  font-size: 16px;
  padding-bottom: 15px;
  color: #2f343c;
  font-weight: 600;
}
.timeline-wrapper {
  width: 100%;
  padding: 20px;
  margin: 20px 0;
  border: 1px solid #ededed;
  cursor: default;
  .el-steps {
    justify-content: center;
  }
}
.order-time-wrapper {
  border: 1px solid #ededed;
  div {
    height: 45px;
    display: flex;
    &:first-child {
      background-color: #f5f5f5;
    }
    span {
      text-align: center;
      line-height: 45px;
      color: #2f343c;
      &:nth-child(1) {
        width: 200px;
      }
      &:nth-child(2) {
        width: 300px;
      }
    }
  }
}
.order-list-wrapper {
  .title {
    font-size: 14px;
    font-weight: 600px;
    margin: 15px 0;
  }
}
.el-table {
  /deep/ .el-table__expanded-cell {
    padding: 0;
  }
}
.batch-list {
  background-color: rgba(239, 242, 249, 0.2);
  padding-left: 35px;
}
.batch-item-wrapper {
  height: 50px;
  display: flex;
  align-items: center;
  .batch-item {
    flex: 1;
    white-space: nowrap;
    margin-right: 20px;
    font-size: 12px;
    .batch-name {
      color: #b7bbc8;
      margin-bottom: 5px;
    }
    .batch-data {
      color: #2f343c;
      display: flex;
      align-items: center;
    }
  }
  .batch-quality {
    display: flex;
    align-items: center;
    .batch-name {
      margin-right: 10px;
      margin-bottom: 0;
    }
  }
}
</style>